import { createInteractableObjectListener } from '../../Inamove/Components/InteractableObject'
import { LevelActionsAction } from '../../Inamove/Components/Level'
import Video from '../../Inamove/Components/Video/Video'
import CinematicContainer from '../../Inamove/Containers/CinematicContainer/CinematicContainer'
import Config from '../../Inamove/Containers/Config'
import GameSceneContainer from '../../Inamove/Containers/GameSceneContainer/GameSceneContainer'
import InventoryContainer from '../../Inamove/Containers/InventoryContainer/InventoryContainer'
import LoadingContainer from '../../Inamove/Containers/LoadingContainer/LoadingContainer'
import AudioController from '../../Inamove/Controllers/AudioController'
import LevelController from '../../Inamove/Controllers/LevelController'
import LoadingController from '../../Inamove/Controllers/LoadingController'

const levelId = 'level11'

export default async function () {
    InventoryContainer.clean()
    CinematicContainer.hide()
    GameSceneContainer.hide()
    InventoryContainer.hide()
    LoadingController.reset()
    LoadingContainer.show()

    const level = await LevelController.loadLevel(levelId)

    const video = new Video(Config.CINEMATIC_PATH + 'V44-ende-tagebau' + Config.VIDEO_FILE_EXT)
    LoadingController.addToQueue(video)
    CinematicContainer.setVideo(video)

    // hide waypoint K182 -> K180
    level.gameScenes.K182.hideWaypoint('K180')
    // hide waypoint K180 -> level12
    level.gameScenes.K180.hideWaypoint('level12')

    createInteractableObjectListener('bagger', () => {
        level.gameScenes.K182.showWaypoint('K180')
        level.gameScenes.K180.showWaypoint('level12')
    })

    await AudioController.addAllToLoadingQueue()
    await LoadingController.processQueue()
    await LoadingContainer.clickStart()

    LoadingContainer.hide()
    GameSceneContainer.show()

    LevelController.startLevel(levelId)

    return new Promise<void>((resolve) => {
        addEventListener('Level', async (event) => {
            // @ts-ignore
            const action: LevelActionsAction = event.detail.action
            // @ts-ignore
            const level: Level = event.detail.level

            if (action === LevelActionsAction.stop && level.id === levelId) {
                CinematicContainer.show()
                await CinematicContainer.play()
                resolve()
            }
        })
    })
}
